// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-staf__container .MuiTableCell-alignRight{
    width: 30%;
}

.league-staf__header {
    display: flex;
    justify-content: space-between;
}

.league-staf__header .baloa-table-column {
    color: var( --primary-dark-color );
    text-transform: capitalize;
    margin-bottom: var( --space-and-half );
}

.league-staf__header__button-options{
    display: flex;
    align-items: flex-end;
    position: relative;
    margin-left: var(--space);
    cursor: pointer;
}

.league-staf__header__button-options span{
    font-weight: var(--font-bold);
}

.league-staf__header__button-options__box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    width: 300px;
    right: 0;
    top: 50px;
    /* margin-right: calc( var(--space) + var(--space-quarter) ); */
    display: none;   
    border-radius: var(--space-half); 
    border: 1px solid var(--new-gray-background-color);
    padding: var(--space-half);
}

.league-staf__header__button-options__box.active{
    display: block;
    z-index: 1;
}

.league-staf__header__button-options__box__box-option {
    cursor: pointer;
    border-radius: 8px;
    padding: var(--space-half);
}
.league-staf__header__button-options__box__box-option:hover {
    background-color: var(--new-background-color);
}

.league-staf__header__button-options__button.small {
    padding: 12px;
}

.league-staf__header__button-options__button .hubicon-person_add{
    grid-area: icon;
    font-size: 25px;
    color: var(--white-color);
    margin-right: 8px;
}

.league-staf__header__button-options__button:hover .hubicon-person_add{
    color: var(--white-color);
}

.league-staf__header__button-options__box__box-option .baloa-names {
    color: var(--primary-very-dark-color);
}

.league-staf__header__button-options__box__box-option .baloa-username {
    color: var(--primary-dark-color);
}

.column-tag.Pending{
    background-color: var(--new-yellow-color);
}

/** estilos para opacar rows en table component cuando edito una fila*/
.league-staf__container.nohover .table-row:hover {
    background-color: unset;
}

.league-staf__container.nohover .table-row {
    opacity: 0.5;
}

.league-staf__container.nohover .table-row.editing {
    opacity: 1;
}

`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-staff/LeagueStaffComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,+DAA+D;IAC/D,aAAa;IACb,gCAAgC;IAChC,kDAAkD;IAClD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,sEAAsE;AACtE;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".league-staf__container .MuiTableCell-alignRight{\n    width: 30%;\n}\n\n.league-staf__header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.league-staf__header .baloa-table-column {\n    color: var( --primary-dark-color );\n    text-transform: capitalize;\n    margin-bottom: var( --space-and-half );\n}\n\n.league-staf__header__button-options{\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    margin-left: var(--space);\n    cursor: pointer;\n}\n\n.league-staf__header__button-options span{\n    font-weight: var(--font-bold);\n}\n\n.league-staf__header__button-options__box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    width: 300px;\n    right: 0;\n    top: 50px;\n    /* margin-right: calc( var(--space) + var(--space-quarter) ); */\n    display: none;   \n    border-radius: var(--space-half); \n    border: 1px solid var(--new-gray-background-color);\n    padding: var(--space-half);\n}\n\n.league-staf__header__button-options__box.active{\n    display: block;\n    z-index: 1;\n}\n\n.league-staf__header__button-options__box__box-option {\n    cursor: pointer;\n    border-radius: 8px;\n    padding: var(--space-half);\n}\n.league-staf__header__button-options__box__box-option:hover {\n    background-color: var(--new-background-color);\n}\n\n.league-staf__header__button-options__button.small {\n    padding: 12px;\n}\n\n.league-staf__header__button-options__button .hubicon-person_add{\n    grid-area: icon;\n    font-size: 25px;\n    color: var(--white-color);\n    margin-right: 8px;\n}\n\n.league-staf__header__button-options__button:hover .hubicon-person_add{\n    color: var(--white-color);\n}\n\n.league-staf__header__button-options__box__box-option .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.league-staf__header__button-options__box__box-option .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.column-tag.Pending{\n    background-color: var(--new-yellow-color);\n}\n\n/** estilos para opacar rows en table component cuando edito una fila*/\n.league-staf__container.nohover .table-row:hover {\n    background-color: unset;\n}\n\n.league-staf__container.nohover .table-row {\n    opacity: 0.5;\n}\n\n.league-staf__container.nohover .table-row.editing {\n    opacity: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
